import React from 'react';
import {useField} from 'formik';
import {t} from 'ttag';

import Wrapper from 'components/wrapper/wrapper';
import * as Title from 'components/title/title';
import {SingleSelect} from 'components/form/form';
import Tooltip from 'components/tooltip/tooltip';
import Text from 'components/text/text';
import {useConnectionListContext} from 'components/connection-list/connection-list-context';
import {useConnectionContext} from 'components/connection-list/connection/connection-context';
import {useSettingsContext} from '../../../settings-context';

const Strategy = () => {
  const {pipelineList} = useConnectionListContext();
  const {connection} = useConnectionContext();
  const {setIsAlertOpen} = useSettingsContext();

  const [{value: pipeline_settings}] = useField('pipeline_settings');

  const [field, , helpers] = useField('strategy');
  const {value} = field;
  const {setValue} = helpers;

  const options = [
    {
      value: 'uniform',
      label: t`Uniform`
    },
    {
      value: 'random',
      label: t`Random`
    }
  ];

  const {pipe_id, status_id} = pipeline_settings[0] || {};

  const {statuses} = pipelineList.find(item => item.id === pipe_id) || {};

  const isUnassembledStage = statuses
    ? !!statuses.find(item => item.id === status_id)?.unsorted
    : false;

  const isDisabled = !status_id || isUnassembledStage || connection.is_limited;

  return (
    <div>
      <Title.H3 style={{marginBottom: 6}}>{t`Strategy`}</Title.H3>

      <Wrapper alignItems="center" noWrap>
        <SingleSelect
          options={options}
          value={!isDisabled ? value : null}
          placeholder={t`Strategy`}
          isDisabled={isDisabled}
          onChange={setValue}
          onClick={() => connection.is_limited && setIsAlertOpen(true)}
        />

        <Tooltip>
          <Text style={{marginBottom: 8}}>
            {t`The least busy manager receives a new request when the strategy is uniform.`}
          </Text>

          <Text>
            {t`A random manager receives a new request when the strategy is random.`}
          </Text>
        </Tooltip>
      </Wrapper>
    </div>
  );
};

export default Strategy;
